import { cn } from "./classNames-DcGnTh2N.js";
import { jsx } from "react/jsx-runtime";
//#region src/blocks/DiagramShared/DiagramSource.tsx
const DiagramSource = ({ code }) => /* @__PURE__ */ jsx("pre", {
	className: cn("tw:my-3 tw:overflow-auto tw:whitespace-pre-wrap tw:break-all", "tw:py-3 tw:px-4", "tw:bg-muted", "tw:rounded-md tw:text-muted-foreground", "tw:text-sm tw:font-mono"),
	children: /* @__PURE__ */ jsx("code", { children: code })
});
//#endregion
export { DiagramSource };

//# sourceMappingURL=DiagramSource-jTwmmi9g.js.map